import styled from 'styled-components'

export const Container = styled.article`
  align-items: center;
  color: #fff;
  display: flex;
  /* display: none; */
  min-height: 45rem;
  flex-direction: column;
  justify-content: flex-start;
  text-align: center;
  width: 90%;

  p {
    margin-top: 2rem;
    text-align: left;
  }
  section {
  }

  .container {
    align-items: center;
    display: flex;
    justify-content: center;
    border: #fff 2px solid;
    border-radius: 5px;
    height: 3rem;
    width: 100%;

    &:active {
      scale: 0.95;
    }

    h4 {
      animation: pulse 1.5s infinite alternate;
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(1.1);
    }
  }

  /* animação de entrada */

  .slide-in {
    opacity: 0;
    animation: slideInAnimation 0.5s ease forwards;
    /* Inicialmente, o elemento está fora da tela à esquerda */
    transform: translateX(-100%);
  }

  @keyframes slideInAnimation {
    from {
      /* Inicialmente, o elemento está fora da tela à esquerda */
      opacity: 0;
      transform: translateX(-100%);
    }
    to {
      /* No final da animação, o elemento está na posição original */
      opacity: 1;
      transform: translateX(0);
    }
  }

  .slide-in:nth-of-type(1) {
    animation-delay: 0.1s;
  }

  .slide-in:nth-of-type(2) {
    animation-delay: 0.5s;
  }

  @media only screen and (min-width: 1000px) {
    align-items: flex-start;
    flex-direction: row;
    justify-content: center;

    .container {
      margin-top: 7rem;
      margin-right: 2rem;
      width: 30%;
      cursor: pointer;
    }

    .infos {
      margin-top: 5rem;
      width: 40%;
    }

    .box {
      height: 100px;
    }
  }
`
